export default "__VITE_ASSET__59bae5b2__"